import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dashboard-container" }
const _hoisted_2 = { class: "stats-grid" }
const _hoisted_3 = { class: "stat-card online" }
const _hoisted_4 = { class: "stat-icon" }
const _hoisted_5 = { class: "stat-content" }
const _hoisted_6 = { class: "stat-number" }
const _hoisted_7 = { class: "stat-card offline" }
const _hoisted_8 = { class: "stat-icon" }
const _hoisted_9 = { class: "stat-content" }
const _hoisted_10 = { class: "stat-number" }
const _hoisted_11 = { class: "stat-card calling" }
const _hoisted_12 = { class: "stat-icon" }
const _hoisted_13 = { class: "stat-card warning" }
const _hoisted_14 = { class: "stat-icon" }
const _hoisted_15 = { class: "stat-content" }
const _hoisted_16 = { class: "stat-number" }
const _hoisted_17 = { class: "main-content" }
const _hoisted_18 = { class: "left-panel" }
const _hoisted_19 = { class: "panel-header" }
const _hoisted_20 = { class: "header-actions" }
const _hoisted_21 = {
  key: 0,
  class: "event-list"
}
const _hoisted_22 = { class: "event-content" }
const _hoisted_23 = { class: "event-title" }
const _hoisted_24 = { class: "event-detail" }
const _hoisted_25 = { class: "event-actions" }
const _hoisted_26 = {
  key: 2,
  class: "loading-placeholder"
}
const _hoisted_27 = { class: "panel-card" }
const _hoisted_28 = {
  key: 0,
  class: "event-list"
}
const _hoisted_29 = { class: "event-content" }
const _hoisted_30 = { class: "event-title" }
const _hoisted_31 = { class: "event-detail" }
const _hoisted_32 = { class: "event-actions" }
const _hoisted_33 = {
  key: 2,
  class: "loading-placeholder"
}
const _hoisted_34 = { class: "panel-card" }
const _hoisted_35 = { class: "panel-header" }
const _hoisted_36 = {
  key: 0,
  class: "event-list"
}
const _hoisted_37 = { class: "event-table" }
const _hoisted_38 = { class: "event-table-header" }
const _hoisted_39 = {
  key: 0,
  class: "event-header-cell"
}
const _hoisted_40 = { class: "event-table-body completed-scroll" }
const _hoisted_41 = { class: "event-cell" }
const _hoisted_42 = { class: "event-cell" }
const _hoisted_43 = { class: "event-cell" }
const _hoisted_44 = {
  key: 0,
  class: "event-cell"
}
const _hoisted_45 = { class: "event-cell" }
const _hoisted_46 = { class: "event-cell" }
const _hoisted_47 = {
  key: 2,
  class: "loading-placeholder"
}
const _hoisted_48 = { class: "right-panel" }
const _hoisted_49 = { class: "panel-card volume-card" }
const _hoisted_50 = { class: "panel-header" }
const _hoisted_51 = { class: "panel-subtitle" }
const _hoisted_52 = { class: "volume-slider-row" }
const _hoisted_53 = { class: "panel-card" }
const _hoisted_54 = {
  key: 0,
  class: "device-overview"
}
const _hoisted_55 = { class: "overview-stats" }
const _hoisted_56 = { class: "overview-item" }
const _hoisted_57 = { class: "overview-number" }
const _hoisted_58 = { class: "overview-percent" }
const _hoisted_59 = { class: "overview-item" }
const _hoisted_60 = { class: "overview-number" }
const _hoisted_61 = { class: "overview-percent" }
const _hoisted_62 = { class: "overview-note" }
const _hoisted_63 = { class: "panel-card" }
const _hoisted_64 = { class: "panel-card" }
const _hoisted_65 = { class: "panel-header" }

import {
  ref,
  onMounted,
  reactive,
  onBeforeUnmount,
  computed,
  watch,
} from "vue";
import {
  User,
  Monitor,
  Phone,
  Warning,
  Refresh,
  Close,
  Timer,
} from "@element-plus/icons-vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { DataService } from "@/services/dataService"; // 确保路径正确
// 修复：使用相对路径替代别名路径，以避免在某些构建环境下的解析问题
import { EventSource, type Event } from "../types/event";
import { formatDateTime } from "@/utils/dateTimeUtils";
import { useCallDialog } from "@/composables/useCallDialog";
import { logger } from "@/utils/logger";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

// --- 响应式状态定义 ---

// 初始化store
const ALERT_VOLUME_STORAGE_KEY = "dashboard_alert_volume";
const DEFAULT_ALERT_VOLUME = 0.6;


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardView',
  setup(__props) {

const store = useStore();

// 取消订阅函数占位符（用于在组件卸载时仅移除监听器，而不关闭全局WebSocket）
let unsubscribe: null | (() => void) = null;
let unsubscribeStatus: null | (() => void) = null;

// 判断是否显示contact名字（admin和super_admin显示）
const showContactName = computed(() => {
  const currentUser = store.getters.getUser;
  const userRole = currentUser?.role || "";
  return userRole === "admin" || userRole === "super_admin";
});

// 是否具备接听/呼叫权限
const canAnswer = computed(() => store.getters.hasPermission("device.call"));

// 计算通话时长
const formatDuration = (startTime: string, endTime: string | null) => {
  if (!startTime || !endTime) return "未知";
  try {
    const start = new Date(startTime);
    const end = new Date(endTime);
    const duration = end.getTime() - start.getTime();
    const minutes = Math.floor(duration / 60000);
    const seconds = Math.floor((duration % 60000) / 1000);
    return `${minutes}分${seconds}秒`;
  } catch (error) {
    return "计算失败";
  }
};

// 获取状态类型
const getStatusType = (status: string) => {
  const typeMap: Record<string, "success" | "info" | "danger" | "warning"> = {
    ended: "success",
    active: "warning",
    failed: "danger",
    cancelled: "info",
    system_timeout: "danger",
    admin_forced_end: "warning",
    connected: "success",
    missed: "danger",
    ongoing: "warning",
  };
  return typeMap[status] || "info";
};

// 获取状态文本
const getStatusText = (status: string) => {
  const textMap: Record<string, string> = {
    ended: "已完成",
    active: "进行中",
    failed: "失败",
    cancelled: "已取消",
    system_timeout: "系统超时",
    admin_forced_end: "管理员结束",
    connected: "已接通",
    missed: "未接通",
    ongoing: "通话中",
  };
  return textMap[status] || "未知";
};

// 响应式数据
const loading = ref(false);
const showAudioUnlockDialog = ref(false);

const clampVolume = (value: number) => Math.min(Math.max(value, 0), 1);

const readAlertVolumeFromStorage = (): number => {
  if (typeof window === "undefined") {
    return DEFAULT_ALERT_VOLUME;
  }
  try {
    const stored = window.localStorage.getItem(ALERT_VOLUME_STORAGE_KEY);
    if (stored !== null) {
      const parsed = parseFloat(stored);
      if (!Number.isNaN(parsed)) {
        return clampVolume(parsed);
      }
    }
  } catch (error) {
    logger.debug("读取本地音量设置失败:", error);
  }
  return DEFAULT_ALERT_VOLUME;
};

const alertVolume = ref(readAlertVolumeFromStorage());
const alertVolumePercent = ref(Math.round(alertVolume.value * 100));

const persistAlertVolume = (value: number) => {
  const normalized = clampVolume(value);
  alertVolume.value = normalized;
  alertVolumePercent.value = Math.round(normalized * 100);
  if (typeof window !== "undefined") {
    try {
      window.localStorage.setItem(
        ALERT_VOLUME_STORAGE_KEY,
        normalized.toString()
      );
    } catch (error) {
      logger.debug("保存音量设置失败:", error);
    }
  }
};

const applyAlertVolumeToElement = (volume: number) => {
  const alertSound = document.getElementById(
    "alertSound"
  ) as HTMLAudioElement | null;
  if (alertSound) {
    alertSound.volume = clampVolume(volume);
  }
};

let previewAudio: HTMLAudioElement | null = null;
let previewTimer: number | null = null;

const stopVolumePreview = () => {
  if (previewTimer) {
    window.clearTimeout(previewTimer);
    previewTimer = null;
  }
  if (previewAudio) {
    previewAudio.pause();
    previewAudio.src = "";
    previewAudio = null;
  }
};

const playVolumePreview = async (volume: number) => {
  stopVolumePreview();
  if (typeof window === "undefined" || typeof Audio === "undefined") {
    logger.warn("当前环境不支持音量预览");
    return;
  }
  try {
    previewAudio = new Audio("/sound/alarm.mp3");
    previewAudio.volume = clampVolume(volume);
    previewAudio.loop = false;
    await previewAudio.play();
    previewTimer = window.setTimeout(() => {
      stopVolumePreview();
    }, 3000);
  } catch (error) {
    logger.warn("音量预览播放失败:", error);
    if (error instanceof Error && error.name === "NotAllowedError") {
      ElMessage.info("请点击页面以允许播放提示音");
    }
    stopVolumePreview();
  }
};

const handleVolumeCommit = (value: number | number[]) => {
  const numeric = Array.isArray(value) ? value[0] ?? 0 : value;
  const normalized = clampVolume(numeric / 100);
  persistAlertVolume(normalized);
  playVolumePreview(normalized);
};

watch(
  alertVolume,
  (value) => {
    applyAlertVolumeToElement(value);
  },
  { immediate: true }
);

// 事件统计
const eventStats = reactive({
  online_devices: 0,
  offline_devices: 0,
  devices_in_call: 0,
  abnormal_events: 0,
});

// 事件列表
const eventLists = reactive({
  waiting_events: [] as Event[],
  ongoing_events: [] as Event[],
  completed_events: [] as Event[],
});

// 等待接听的事件（用于被动接听）
const waitingEvents = computed(() => {
  return eventLists.waiting_events || [];
});

// 是否有等待接听的呼叫
const hasWaitingCalls = computed(() => {
  return waitingEvents.value.length > 0;
});

// 进行中的事件（正在通话）
const ongoingEvents = computed(() => {
  return eventLists.ongoing_events || [];
});

const completedEventsSorted = computed(() => {
  return eventLists.completed_events || [];
});

// 设备总览
const deviceOverview = reactive({
  overview: {} as Record<string, number>,
  percentages: {} as Record<string, string>,
  total_devices: 0,
});

// 热点区域
const hotspotAreas = ref([]);

// 系统日志
const systemLogs = ref([]);

// 使用通用通话弹窗逻辑
const {
  currDeviceId,
  currEventId,
  handleCallResponse,
  startWebRTC,
  leaveRoom,
  updateMessageBoxToAnswering,
  closeMessageBox,
  alertBroadcast,
} = useCallDialog();

// 路由实例
const router = useRouter();

// 跳转到通话记录页面
const goToCallRecords = () => {
  router.push({ name: "通话记录" });
};

const confirmUnlockAudio = async () => {
  try {
    await unlockRinger();
  } finally {
    showAudioUnlockDialog.value = false;
  }
};

// --- API 调用 ---

// 获取仪表盘数据
const fetchDashboardData = async () => {
  loading.value = true;
  try {
    // 并行获取所有数据
    const [stats, events, overview] = await Promise.all([
      DataService.getDashboardStats(),
      DataService.getDashboardEventLists(),
      DataService.getDeviceOverview(),
    ]);

    // 更新事件统计
    if (stats) {
      if ("data" in stats && stats.data && stats.data.code === 0) {
        // AxiosResponse 格式
        const statsData = stats.data.data;
        Object.assign(eventStats, statsData);
      } else if ("total_events" in stats) {
        // Fallback 格式
        Object.assign(eventStats, stats);
      }
    }

    // 更新事件列表
    if (events) {
      if ("data" in events && events.data && events.data.code === 0) {
        // AxiosResponse 格式
        const eventsData = events.data.data;
        eventLists.waiting_events = eventsData.waiting_events || [];
        eventLists.ongoing_events = eventsData.ongoing_events || [];
        eventLists.completed_events = eventsData.completed_events || [];
      } else if ("waiting_events" in events) {
        // Fallback 格式
        eventLists.waiting_events = events.waiting_events || [];
        eventLists.ongoing_events = events.ongoing_events || [];
        eventLists.completed_events = events.completed_events || [];
      }
    }

    // 更新设备总览
    if (overview) {
      if ("data" in overview && overview.data && overview.data.code === 0) {
        // AxiosResponse 格式
        const overviewData = overview.data.data;
        Object.assign(deviceOverview, overviewData);
      } else if ("overview" in overview) {
        // Fallback 格式
        Object.assign(deviceOverview, overview);
      }
    }
  } catch (error) {
    ElMessage.error("获取仪表盘数据失败");
    console.error(error);
  } finally {
    loading.value = false;
  }
};

// --- 生命周期钩子 ---

onMounted(() => {
  // 从全局 store 恢复会话内的解锁状态（跨路由不丢失）
  try {
    const unlockedInStore = store.getters.getAudioUnlocked;
    if (unlockedInStore) {
      isAudioUnlocked = true;
    }
  } catch (e) {
    logger.debug("读取全局音频解锁状态失败:", e);
  }

  fetchDashboardData();

  // 初始化音频播放权限 - 在页面加载时尝试播放一次（静音）
  const initAudioPermission = () => {
    const alertSound = document.getElementById(
      "alertSound"
    ) as HTMLAudioElement;
    if (alertSound) {
      logger.info("初始化音频播放权限...");
      alertSound.muted = true;
      alertSound
        .play()
        .then(() => {
          alertSound.pause();
          alertSound.muted = false;
          logger.info("音频播放权限初始化成功");
        })
        .catch((e) => {
          logger.warn("音频播放权限初始化失败:", e);
        });
    }
  };

  // 延迟初始化，确保页面完全加载
  setTimeout(initAudioPermission, 1000);

  bindOneTimeUnlock();

  // 首次加载即弹出解锁弹窗，避免用户忽略点击
  if (!isAudioUnlocked) {
    showAudioUnlockDialog.value = true;
  }

  // 监听等待接听的呼叫，自动播放告警声音
  watch(hasWaitingCalls, (newValue, oldValue) => {
    logger.info(`等待接听呼叫状态变化: ${oldValue} -> ${newValue}`);
    logger.info(`当前等待事件数量: ${waitingEvents.value.length}`);
    logger.info(`等待事件详情:`, waitingEvents.value);

    if (newValue && !oldValue) {
      // 从无到有，开始播放告警声音
      logger.info("开始播放告警声音和红光闪烁");
      if (!isAudioUnlocked) {
        showAudioUnlockDialog.value = true;
        bindOneTimeUnlock();
      }
      playAlertSound();
    } else if (!newValue && oldValue) {
      // 从有到无，停止告警声音
      logger.info("停止告警声音和红光闪烁");
      stopAlertSound();
    }
  });

  // 添加WebSocket消息监听
  const websocketManager = import("../services/websocketManager").then(
    (m) => m.default
  );

  websocketManager
    .then((wsManager) => {
      // 自动连接WebSocket
      wsManager.autoConnect();

      // 监听WebSocket消息
      unsubscribe = wsManager.onMessage(async (msg: any) => {
        logger.info("DashboardView 收到WebSocket消息:", msg);
        console.log("🔥 [DashboardView WebSocket] 收到消息:", msg);

        // 安全访问消息属性
        if (typeof msg === "object" && msg !== null) {
          // 处理来电通知
          if (msg.type === "notify" && msg.action === "start_call") {
            logger.info("收到来电通知:", msg.data);
            ElMessage.info(`设备 ${msg.data.device_id} 发起呼叫`);

            // 刷新事件列表以显示新的呼叫
            await fetchDashboardData();
          }

          // 处理通话结束通知
          else if (msg.type === "notify" && msg.action === "end_call") {
            logger.info("收到通话结束通知:", msg.data);
            console.log("🔥 [DashboardView] 收到通话结束通知:", msg.data);

            // 根据结束原因显示不同的提示信息
            const reason =
              msg.data?.reason || msg.data?.metadata?.reason || "未知原因";
            const deviceId = msg.data?.device_id || "未知设备";
            let messageText = `设备 ${deviceId} 结束通话`;

            if (reason === "device_offline" || reason.includes("设备离线")) {
              messageText = `设备 ${deviceId} 离线，通话已强制结束`;
              console.log("🔥 [DashboardView] 设备离线导致通话结束");
              ElMessage.warning(messageText);
            } else if (
              reason === "system_timeout" ||
              reason.includes("系统强制结束") ||
              reason.includes("房间监控")
            ) {
              messageText = `系统检测到异常，通话已强制结束`;
              console.log("🔥 [DashboardView] 系统超时或房间监控强制结束通话");
              ElMessage.warning(messageText);
            } else if (reason === "volcengine_room_destroy") {
              messageText = `设备 ${deviceId} 通话被火山引擎强制结束`;
              console.log("🔥 [DashboardView] 火山引擎强制结束通话");
              ElMessage.warning(messageText);
            } else {
              console.log("🔥 [DashboardView] 其他原因结束通话:", reason);
              ElMessage.info(messageText);
            }

            console.log("🔥 [DashboardView] 通话结束通知处理:", {
              reason,
              messageText,
              data: msg.data,
            });

            // 检查是否是当前设备的通话，如果是则关闭弹窗
            if (
              (currEventId.value && currEventId.value === msg.data?.event_id) ||
              (currDeviceId.value && currDeviceId.value === msg.data?.device_id)
            ) {
              logger.info("收到当前设备的通话结束通知，关闭弹窗");
              console.log("🔥 [DashboardView] 关闭当前设备通话弹窗");
              closeMessageBox();
            }

            // 刷新事件列表
            console.log("🔥 [DashboardView] 刷新事件列表");
            await fetchDashboardData();
            // 若仍有等待事件，确保恢复响铃
            ensureRinging();
          }

          // 处理被他人接起通知（唯一接听）
          else if (
            msg.type === "notify" &&
            (msg.action === "call_taken" || msg.action === "call_confirmed")
          ) {
            try {
              const takenEventId = msg?.data?.event_id;
              // 中文提示：已被其他人处理
              ElMessage.info("已被其他人处理");

              // 本地移除等待队列中的该事件（即时反馈）
              if (takenEventId && Array.isArray(eventLists.waiting_events)) {
                eventLists.waiting_events = eventLists.waiting_events.filter(
                  (e: any) => e.event_id !== takenEventId
                );
              }

              // 轻量刷新以校准最终一致性
              await fetchDashboardData();
            } catch (e) {
              logger.warn("处理 call_taken 通知时出错:", e);
            }
          }

          // 处理通话结束响应（web端挂断时）
          else if (msg.type === "response" && msg.action === "end_call") {
            logger.info("收到通话结束响应:", msg.data);
            ElMessage.info("通话已结束");

            // 检查是否是当前设备的通话，如果是则关闭弹窗
            if (
              (currEventId.value && currEventId.value === msg.data?.event_id) ||
              (currDeviceId.value && currDeviceId.value === msg.data?.device_id)
            ) {
              logger.info("收到当前设备的通话结束响应，关闭弹窗");
              closeMessageBox();
            }

            // 刷新事件列表
            await fetchDashboardData();
            // 若仍有等待事件，确保恢复响铃
            ensureRinging();
          }

          // 处理系统强制登出
          else if (msg.type === "system" && msg.action === "force_logout") {
            logger.warn("收到强制登出通知");
            // 这里可以添加登出逻辑
          }

          // 处理token验证失败
          else if (msg.type === "error" && msg.action === "auth_failed") {
            logger.error("WebSocket认证失败");
            // 这里可以添加重新登录逻辑
          }
        }
      });

      // 监听WebSocket状态变化
      unsubscribeStatus = wsManager.onStatusChange((status) => {
        logger.info("DashboardView WebSocket状态:", status);
        if (status === "Connected") {
          logger.info("WebSocket连接成功，可以接收消息");
        } else if (status === "Disconnected") {
          logger.warn("WebSocket连接断开");
        }
      });
    })
    .catch((error) => {
      logger.error("DashboardView WebSocket初始化失败:", error);
    });
});

// 组件卸载时清理订阅
onBeforeUnmount(() => {
  // 仅清理当前页面注册的监听器，不断开全局WebSocket连接
  if (typeof unsubscribe === "function") {
    try {
      unsubscribe();
    } catch (e) {
      logger.warn("移除WebSocket消息监听器时出错:", e);
    } finally {
      unsubscribe = null;
    }
  }

  if (typeof unsubscribeStatus === "function") {
    try {
      unsubscribeStatus();
    } catch (e) {
      logger.warn("移除WebSocket状态监听器时出错:", e);
    } finally {
      unsubscribeStatus = null;
    }
  }
});

// --- 辅助函数和事件处理 ---

const answerCall = async (event: Event) => {
  if (!canAnswer.value) {
    ElMessage.warning("当前角色无接听权限");
    return;
  }
  try {
    // 停止告警声音
    stopAlertSound();

    // 检查WebSocket连接状态
    const websocketManager = await import("../services/websocketManager").then(
      (m) => m.default
    );

    // 确保WebSocket已连接
    if (websocketManager.getStatus() !== "Connected") {
      logger.warn("WebSocket未连接，尝试自动连接...");
      websocketManager.autoConnect();

      // 等待连接建立
      await new Promise((resolve, reject) => {
        const timeout = setTimeout(() => {
          reject(new Error("WebSocket连接超时"));
        }, 5000);

        const unsubscribe = websocketManager.onStatusChange((status) => {
          if (status === "Connected") {
            clearTimeout(timeout);
            unsubscribe();
            resolve(true);
          } else if (status === "Disconnected") {
            clearTimeout(timeout);
            unsubscribe();
            reject(new Error("WebSocket连接失败"));
          }
        });
      });
    }

    // 构建确认通话消息
    const confirmMessage = {
      type: "command",
      action: "confirm_call",
      messageId: `msg_${Date.now()}`,
      timestamp: new Date().toISOString(),
      data: {
        event_id: event.event_id,
        source: "frontend",
      },
    };

    // 发送确认通话消息
    websocketManager.send(confirmMessage);

    ElMessage.success(`正在接听来自 ${event.device_id} 的呼叫...`);

    // 使用Promise包装消息监听，确保只处理一次
    const responsePromise = new Promise((resolve, reject) => {
      let isHandled = false;
      let timeoutId: any = null;

      const unsubscribe = websocketManager.onMessage((message) => {
        // 防止重复处理
        if (isHandled) {
          return;
        }

        // 只处理confirm_call响应，忽略其他消息
        if (message.type === "response" && message.action === "confirm_call") {
          isHandled = true;
          unsubscribe(); // 立即取消订阅

          // 清理超时定时器
          if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = null;
          }

          if (message.code === 0) {
            ElMessage.success("接听成功，正在建立连接...");
            // 构造设备信息
            const device = {
              device_id: event.device_id,
              device_name: event.device_id, // 如果没有设备名称，使用设备ID
            };
            // 直接处理通话，弹出通话界面 - 设备端发起的呼叫
            handleCallResponse(message, device, false);
            resolve(true);
          } else {
            ElMessage.error(`接听失败: ${message.message || "未知错误"}`);
            reject(new Error(message.message || "接听失败"));
          }
        }
        // 注意：不处理其他类型的消息，避免与DashboardView的全局监听器冲突
      });

      // 设置超时
      timeoutId = setTimeout(() => {
        if (!isHandled) {
          isHandled = true;
          unsubscribe();
          reject(new Error("接听超时，请检查设备状态"));
        }
      }, 10000); // 10秒超时
    });

    // 等待响应
    await responsePromise;
  } catch (error) {
    console.error("接听呼叫时出错:", error);
    const errorMessage = error instanceof Error ? error.message : "请稍后重试";
    ElMessage.error(`接听呼叫失败: ${errorMessage}`);
  }
};

const endCall = async (event: Event) => {
  try {
    // 先设置全局状态，确保 leaveRoom() 组包包含 event_id / device_id
    currDeviceId.value = (event as any)?.device_id as any;
    currEventId.value = (event as any)?.event_id as any;
    // 使用通用的结束通话逻辑
    await leaveRoom();
    ElMessage.success(`已结束来自 ${event.device_id} 的呼叫`);
  } catch (error) {
    console.error("结束通话时出错:", error);
    ElMessage.error("结束通话失败，请稍后重试");
  }
};

const viewRecord = async (event: Event) => {
  // 获取当前用户信息
  const currentUser = store.getters.getUser;
  const userRole = currentUser?.role || "";

  // 计算通话时长
  const formatDuration = (startTime: string, endTime: string | null) => {
    if (!startTime || !endTime) return "未知";
    try {
      const start = new Date(startTime);
      const end = new Date(endTime);
      const duration = end.getTime() - start.getTime();
      const minutes = Math.floor(duration / 60000);
      const seconds = Math.floor((duration % 60000) / 1000);
      return `${minutes}分${seconds}秒`;
    } catch (error) {
      return "计算失败";
    }
  };

  // 判断是否显示contact名字（admin和super_admin显示）
  const showContactName = userRole === "admin" || userRole === "super_admin";

  try {
    // 调用API获取详细的事件信息和日志
    const response = await DataService.getEventDetail(event.event_id);
    console.log("事件详情API响应:", response); // 调试日志

    if (!response || response.data?.code !== 0) {
      ElMessage.error("获取事件详情失败");
      return;
    }

    const eventDetail = response.data.data;
    const eventData = eventDetail.event;
    const logs = eventDetail.logs || [];

    // 构建详情信息
    const details = {
      deviceId: eventData.device_id,
      eventId: eventData.event_id,
      status: eventData.status,
      duration: formatDuration(eventData.start_time, eventData.end_time),
      contactName: eventData.contact_name,
      startTime: formatDateTime(eventData.start_time),
      endTime: formatDateTime(eventData.end_time),
      logs: logs,
    };

    // 构建日志HTML
    const logsHtml =
      logs.length > 0
        ? `
      <div style="margin-top: 15px;">
        <h4 style="margin-bottom: 10px; color: #409EFF;">操作日志</h4>
        <div style="max-height: 300px; overflow-y: auto; border: 1px solid #e4e7ed; border-radius: 4px; padding: 10px;">
          ${logs
            .map(
              (log: any) => `
            <div style="margin-bottom: 8px; padding: 8px; background: #f5f7fa; border-radius: 4px; border-left: 3px solid #409EFF;">
              <div style="font-weight: bold; color: #303133;">${
                log.action
              }</div>
              <div style="font-size: 12px; color: #909399; margin-top: 2px;">
                操作者: ${log.operator} | 时间: ${new Date(
                log.created_at
              ).toLocaleString()}
              </div>
              ${
                log.message
                  ? `<div style="font-size: 12px; color: #606266; margin-top: 2px;">${log.message}</div>`
                  : ""
              }
            </div>
          `
            )
            .join("")}
        </div>
      </div>
    `
        : "";

    // 显示详情对话框
    await ElMessageBox.confirm(
      `
      <div style="text-align: left;">
        <p><strong>设备编号:</strong> ${details.deviceId}</p>
        <p><strong>事件ID:</strong> ${details.eventId}</p>
        <p><strong>通话状态:</strong> ${details.status}</p>
        <p><strong>通话时长:</strong> ${details.duration}</p>
        ${
          showContactName
            ? `<p><strong>处理人员:</strong> ${
                details.contactName || "未知"
              }</p>`
            : ""
        }
        <p><strong>开始时间:</strong> ${details.startTime}</p>
        <p><strong>结束时间:</strong> ${details.endTime}</p>
        ${logsHtml}
      </div>
      `,
      "通话记录详情",
      {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "确定",
        cancelButtonText: "关闭",
        customClass: "call-record-details-dialog",
      }
    );
  } catch (error) {
    // 忽略取消操作的错误
    if (error !== "cancel" && error !== "close") {
      console.error("弹窗错误:", error);
      ElMessage.error("获取事件详情失败");
    }
  }
};

// 修复：添加辅助函数来处理动态数据
const getEventItemClass = (event: Event) => {
  return event.event_source === EventSource.DEVICE
    ? "event-item user-highlight"
    : "event-item system-highlight";
};

const getEventStatusClass = (event: Event) => {
  return event.event_source === EventSource.DEVICE
    ? "event-status user"
    : "event-status system";
};

const getEventSourceText = (event: Event) => {
  return event.event_source === EventSource.DEVICE ? "用户" : "系统";
};

const formatEventTime = (time: string | Date) => {
  if (!time) return "";
  return formatDateTime(time.toString());
};

const getDeviceStatusLabel = (statusKey: string) => {
  const labels: Record<string, string> = {
    online: "在线设备",
    offline: "离线设备",
  };
  return labels[statusKey] || statusKey;
};

// 播放告警声音
const playAlertSound = () => {
  if (!canAnswer.value) {
    logger.info("当前角色无接听权限，跳过告警声音");
    return;
  }
  logger.info(`[playAlertSound] 调用，isAudioUnlocked=${isAudioUnlocked}`);
  if (!isAudioUnlocked) {
    logger.warn("未解锁音频，等待用户手势后再播放");
    bindOneTimeUnlock();
    ElMessage.info("请点击页面任意位置以开启告警声音");
    return;
  }
  logger.info("开始播放告警声音...");
  const alertSound = document.getElementById("alertSound") as HTMLAudioElement;
  if (alertSound) {
    logger.info("找到音频元素，src:", alertSound.src);
    logger.info("音频元素状态:", {
      readyState: alertSound.readyState,
      paused: alertSound.paused,
      ended: alertSound.ended,
      currentTime: alertSound.currentTime,
      duration: alertSound.duration,
    });

    try {
      // 移除 loop=true，改用 ended 事件手动循环
      alertSound.loop = false;
      alertSound.volume = clampVolume(alertVolume.value);
      alertSound.muted = false;

      // 绑定循环播放事件（如果尚未绑定）
      if (!alertSound.dataset.loopBound) {
        alertSound.addEventListener("ended", () => {
          // 根据全局标志判断是否应该循环
          if (shouldLoopAlert) {
            logger.info("音频播放结束，重新开始循环播放");
            alertSound.currentTime = 0;
            alertSound.play().catch((e) => {
              logger.warn("循环播放失败:", e);
            });
          }
        });
        alertSound.dataset.loopBound = "true";
      }

      // 设置循环标志为 true
      shouldLoopAlert = true;
      logger.info(
        `音频设置: volume=${alertSound.volume}, loop=false(手动循环), muted=false, shouldLoopAlert=true`
      );

      alertSound
        .play()
        .then(() => {
          logger.info("告警声音播放成功");
          // 播放后再次检查状态
          setTimeout(() => {
            logger.info("播放中状态检查:", {
              paused: alertSound.paused,
              currentTime: alertSound.currentTime,
              volume: alertSound.volume,
              muted: alertSound.muted,
              duration: alertSound.duration,
            });
          }, 500);
        })
        .catch((e) => {
          logger.error("播放告警声音失败:", e);
          logger.error("错误详情:", {
            name: e.name,
            message: e.message,
            code: e.code,
          });

          // 如果是用户交互问题，尝试多种解决方案
          if (e.name === "NotAllowedError") {
            bindOneTimeUnlock();
            ElMessage.info("请点击页面以开启告警声音");
          }
        });
    } catch (e) {
      logger.error("设置音频属性失败:", e);
    }
  } else {
    logger.error("未找到告警声音元素");
  }
};

// 停止告警声音
const stopAlertSound = () => {
  // 先设置循环标志为 false，阻止 ended 事件继续循环
  shouldLoopAlert = false;
  const alertSound = document.getElementById("alertSound") as HTMLAudioElement;
  if (alertSound) {
    alertSound.pause();
    alertSound.currentTime = 0;
    logger.info("告警声音已停止，shouldLoopAlert=false");
  }
};

// 判断告警声音是否正在播放
const isAlertPlaying = (): boolean => {
  const el = document.getElementById("alertSound") as HTMLAudioElement | null;
  if (!el) return false;
  return !el.paused && !el.ended && el.currentTime > 0;
};

// 根据等待事件数量，确保响铃状态正确
const ensureRinging = () => {
  try {
    if (hasWaitingCalls.value && canAnswer.value) {
      if (!isAlertPlaying()) {
        playAlertSound();
      }
    } else {
      if (isAlertPlaying()) {
        stopAlertSound();
      }
    }
  } catch (e) {
    logger.warn("ensureRinging 执行失败:", e);
  }
};

let ringUnlockBound = false;
let isAudioUnlocked = false;
let shouldLoopAlert = false; // 控制是否应该循环播放告警声音

const unlockRinger = async () => {
  try {
    const winAny = window as any;
    const AC = winAny.AudioContext || winAny.webkitAudioContext;
    if (AC) {
      if (!winAny.__ringAudioCtx) winAny.__ringAudioCtx = new AC();
      const ctx = winAny.__ringAudioCtx as AudioContext;
      if (ctx && ctx.state === "suspended") {
        await ctx.resume();
      }
    }
    const el = document.getElementById("alertSound") as HTMLAudioElement | null;
    if (el) {
      const prevMuted = el.muted;
      const prevVolume = el.volume;
      try {
        el.muted = true;
        el.volume = 0;
        await el.play().catch((err) => {
          logger.debug("预热告警音频失败:", err);
        });
      } catch (playError) {
        logger.debug("unlockRinger 预热阶段异常:", playError);
      } finally {
        el.pause();
        el.currentTime = 0;
        el.muted = prevMuted;
        el.volume = prevVolume;
      }
    }
  } catch (error) {
    logger.warn("unlockRinger 执行失败:", error);
  }
  // 用户已完成手势，标记为已解锁并根据等待事件恢复响铃
  logger.info(
    "[unlockRinger] 完成，设置 isAudioUnlocked=true 并调用 ensureRinging"
  );
  isAudioUnlocked = true;
  try {
    store.commit("setAudioUnlocked", true);
  } catch (e) {
    logger.debug("提交 setAudioUnlocked 失败:", e);
  }
  ensureRinging();
  // 解锁成功后，若弹窗存在则关闭
  showAudioUnlockDialog.value = false;
};

const bindOneTimeUnlock = () => {
  if (ringUnlockBound) {
    logger.info("[bindOneTimeUnlock] 已绑定，跳过");
    return;
  }
  logger.info("[bindOneTimeUnlock] 绑定一次性用户手势监听");
  const handler = async () => {
    logger.info("[bindOneTimeUnlock] 用户手势触发，调用 unlockRinger");
    try {
      await unlockRinger();
    } finally {
      document.removeEventListener("pointerdown", handler as any);
      document.removeEventListener("touchstart", handler as any);
      document.removeEventListener("keydown", handler as any);
    }
  };
  document.addEventListener("pointerdown", handler, { once: true } as any);
  document.addEventListener("touchstart", handler, { once: true } as any);
  document.addEventListener("keydown", handler, { once: true } as any);
  ringUnlockBound = true;
};

// 强制刷新页面
const forceRefresh = () => {
  logger.info("强制刷新页面...");
  window.location.reload();
};

// 测试弹窗功能
const testAlertBroadcast = async () => {
  try {
    logger.info("测试弹窗功能...");
    await alertBroadcast("test_device_001", "测试设备");
    logger.info("测试弹窗显示成功");
  } catch (error) {
    logger.error("测试弹窗失败:", error);
    ElMessage.error(
      "测试弹窗失败: " + (error instanceof Error ? error.message : "未知错误")
    );
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_slider = _resolveComponent("el-slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[29] || (_cache[29] = _createElementVNode("audio", {
      id: "alertSound",
      src: "/sound/alarm.mp3",
      preload: "auto"
    }, null, -1)),
    _createVNode(_component_el_dialog, {
      modelValue: showAudioUnlockDialog.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showAudioUnlockDialog).value = $event)),
      title: "开启告警声音",
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      "show-close": false,
      width: "360px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirmUnlockAudio
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("开启", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _cache[3] || (_cache[3] = _createElementVNode("div", null, "为遵循浏览器策略，请点击“开启”以允许播放告警声音。", -1))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(User))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(deviceOverview.overview.online || 0), 1),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "stat-label" }, "在线设备", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Monitor))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(deviceOverview.overview.offline || 0), 1),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "stat-label" }, "离线设备", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Phone))
            ]),
            _: 1
          })
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "stat-content" }, [
          _createElementVNode("div", { class: "stat-number" }, _toDisplayString(0)),
          _createElementVNode("div", { class: "stat-label" }, "通话中设备")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Warning))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, _toDisplayString(eventStats.abnormal_events || 0), 1),
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "stat-label" }, "异常事件 (失败)", -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", {
          class: _normalizeClass(["panel-card", { 'alert-flashing': hasWaitingCalls.value }])
        }, [
          _createElementVNode("div", _hoisted_19, [
            _cache[9] || (_cache[9] = _createElementVNode("h3", null, "实时事件列表 (活动中)", -1)),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: fetchDashboardData,
                loading: loading.value,
                style: {"margin-left":"12px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Refresh))
                    ]),
                    _: 1
                  }),
                  _cache[8] || (_cache[8] = _createTextVNode(" 刷新数据 ", -1))
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ]),
          (!loading.value && waitingEvents.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(waitingEvents.value, (event) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: event.id,
                    class: _normalizeClass(getEventItemClass(event))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(getEventStatusClass(event))
                    }, _toDisplayString(getEventSourceText(event)), 3),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, _toDisplayString(event.device_id), 1),
                      _createElementVNode("div", _hoisted_24, _toDisplayString(formatEventTime(event.created_at)) + " 等待接入... ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_el_button, {
                        type: "success",
                        size: "small",
                        onClick: ($event: any) => (answerCall(event)),
                        disabled: !canAnswer.value
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Phone))
                            ]),
                            _: 1
                          }),
                          _cache[10] || (_cache[10] = _createTextVNode(" 接听 ", -1))
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"])
                    ])
                  ], 2))
                }), 128))
              ]))
            : (!loading.value)
              ? (_openBlock(), _createBlock(_component_el_empty, {
                  key: 1,
                  description: "暂无活动事件"
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_26, "加载中..."))
        ], 2),
        _createElementVNode("div", _hoisted_27, [
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "panel-header" }, [
            _createElementVNode("h3", null, "进行中事件 (正在通话)")
          ], -1)),
          (!loading.value && ongoingEvents.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ongoingEvents.value, (event) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: event.id,
                    class: _normalizeClass(getEventItemClass(event))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(getEventStatusClass(event))
                    }, _toDisplayString(getEventSourceText(event)), 3),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, _toDisplayString(event.device_id), 1),
                      _createElementVNode("div", _hoisted_31, _toDisplayString(formatEventTime(event.start_time)) + " 通话中... ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_el_button, {
                        type: "warning",
                        size: "small",
                        onClick: ($event: any) => (endCall(event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Close))
                            ]),
                            _: 1
                          }),
                          _cache[11] || (_cache[11] = _createTextVNode(" 结束 ", -1))
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ], 2))
                }), 128))
              ]))
            : (!loading.value)
              ? (_openBlock(), _createBlock(_component_el_empty, {
                  key: 1,
                  description: "暂无进行中事件"
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_33, "加载中..."))
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _cache[14] || (_cache[14] = _createElementVNode("h3", null, "完成事件", -1)),
            _createVNode(_component_el_button, {
              link: "",
              size: "small",
              onClick: goToCallRecords
            }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode("查看更多", -1)
              ]))]),
              _: 1
            })
          ]),
          (!loading.value && eventLists.completed_events?.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "event-header-cell" }, "设备编号", -1)),
                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "event-header-cell" }, "通话时间", -1)),
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "event-header-cell" }, "通话状态", -1)),
                    (showContactName.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, " 处理人员 "))
                      : _createCommentVNode("", true),
                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "event-header-cell" }, "通话时长", -1)),
                    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "event-header-cell" }, "操作", -1))
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(completedEventsSorted.value, (event) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: event.id,
                        class: "event-table-row"
                      }, [
                        _createElementVNode("div", _hoisted_41, _toDisplayString(event.device_id), 1),
                        _createElementVNode("div", _hoisted_42, _toDisplayString(formatEventTime(event.start_time)), 1),
                        _createElementVNode("div", _hoisted_43, [
                          _createVNode(_component_el_tag, {
                            type: getStatusType(event.status),
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(getStatusText(event.status)), 1)
                            ]),
                            _: 2
                          }, 1032, ["type"])
                        ]),
                        (showContactName.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(event.contact_name || "未知"), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_45, _toDisplayString(formatDuration(event.start_time, event.end_time)), 1),
                        _createElementVNode("div", _hoisted_46, [
                          _createVNode(_component_el_button, {
                            type: "info",
                            size: "small",
                            onClick: ($event: any) => (viewRecord(event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Timer))
                                ]),
                                _: 1
                              }),
                              _cache[20] || (_cache[20] = _createTextVNode(" 详情 ", -1))
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : (!loading.value)
              ? (_openBlock(), _createBlock(_component_el_empty, {
                  key: 1,
                  description: "暂无已完成事件"
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_47, "加载中..."))
        ])
      ]),
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _cache[21] || (_cache[21] = _createElementVNode("h3", null, "报警音量", -1)),
            _createElementVNode("span", _hoisted_51, _toDisplayString(Math.round(alertVolume.value * 100)) + "%", 1)
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createVNode(_component_el_slider, {
              modelValue: alertVolumePercent.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((alertVolumePercent).value = $event)),
              min: 0,
              max: 100,
              step: 5,
              onChange: handleVolumeCommit
            }, null, 8, ["modelValue"])
          ]),
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "volume-hint" }, " 拖动滑块调整音量，松开后会播放 3 秒提示音 ", -1))
        ]),
        _createElementVNode("div", _hoisted_53, [
          _cache[25] || (_cache[25] = _createElementVNode("div", { class: "panel-header" }, [
            _createElementVNode("h3", null, "设备状态总览")
          ], -1)),
          (deviceOverview.total_devices > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, _toDisplayString(deviceOverview.overview.online || 0), 1),
                    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "overview-label" }, "在线设备", -1)),
                    _createElementVNode("div", _hoisted_58, _toDisplayString(deviceOverview.percentages.online || "0.00%"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, _toDisplayString(deviceOverview.overview.offline || 0), 1),
                    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "overview-label" }, "离线设备", -1)),
                    _createElementVNode("div", _hoisted_61, _toDisplayString(deviceOverview.percentages.offline || "0.00%"), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("small", null, "总设备数：" + _toDisplayString(deviceOverview.total_devices) + "台", 1)
                ])
              ]))
            : (_openBlock(), _createBlock(_component_el_empty, {
                key: 1,
                description: "暂无设备数据"
              }))
        ]),
        _createElementVNode("div", _hoisted_63, [
          _cache[26] || (_cache[26] = _createElementVNode("div", { class: "panel-header" }, [
            _createElementVNode("h3", null, "呼叫热点区域排行"),
            _createElementVNode("span", { class: "panel-subtitle" }, "识别高风险区域")
          ], -1)),
          _createVNode(_component_el_empty, { description: "热点排行开发中" })
        ]),
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _cache[28] || (_cache[28] = _createElementVNode("h3", null, "系统日志", -1)),
            _createVNode(_component_el_button, {
              link: "",
              size: "small"
            }, {
              default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                _createTextVNode("查看全部", -1)
              ]))]),
              _: 1
            })
          ]),
          _createVNode(_component_el_empty, { description: "日志功能开发中" })
        ])
      ])
    ])
  ]))
}
}

})